import React from "react"
import { Row, Col} from "react-bootstrap"
import "../Styles/index.scss"
import RightImageSlider from "./rightimageslider"
import LeftImageSlider from "./leftimageslider"
const Imageslider = () => {
  return (
      <div className="sliders">
        <Row className="justify-content-md-center">
          {/* //...............................left slider................. */}
          <Col md={8} lg={8}>
            <LeftImageSlider className="left-slider-comp" />
          </Col>
          {/* //...............................right slider................. */}
          <Col md={4} lg={4}> 
            <RightImageSlider className="right-slider-comp" />
          </Col>
        </Row>
      </div>
  )
}

export default Imageslider
